import React from "react";
import "./FleetCoreFuelTransactionEvidence.css";

import fleetcoreFuelTransactionEvidencePhotoJpg from "../../images/fleetcore-fuel-transaction-evidence-refuelling.jpg";
import fleetcoreFuelTransactionEvidencePhotoWebp from "../../images/fleetcore-fuel-transaction-evidence-refuelling.webp";
import fleetcoreFuelTransactionEvidenceRecord from "../../images/fleetcore-fuel-transaction-evidence-record.svg";

export default function FleetCoreFuelTransactionEvidence() {
  return (
    <section className="fleetcore-fuel-transaction-evidence" id="fleetcore-fuel-evidence" aria-labelledby="fleetcore-fuel-transaction-evidence-title">
      <div className="fleetcore-fuel-transaction-evidence__inner">
        <div className="fleetcore-fuel-transaction-evidence__copy">
          <p className="fleetcore-fuel-transaction-evidence__eyebrow">RECORD THE FULL FUEL EVENT</p>
          <h2 id="fleetcore-fuel-transaction-evidence-title">Prove who fuelled what—and when.</h2>
          <p className="fleetcore-fuel-transaction-evidence__body">Before fuel, capture vehicle registration, dashboard and driver evidence. After fuel, capture the pump reading. FleetCore connects identity, vehicle, mileage and litres to one transaction.</p>
          <div className="fleetcore-fuel-transaction-evidence__tags"><span>Before fuel</span><span>After fuel</span></div>
          <p className="fleetcore-fuel-transaction-evidence__principle">Every litre linked to its operational evidence.</p>
        </div>
        <div className="fleetcore-fuel-transaction-evidence__visual">
          <picture><source srcSet={fleetcoreFuelTransactionEvidencePhotoWebp} type="image/webp" /><img src={fleetcoreFuelTransactionEvidencePhotoJpg} alt="Commercial fleet driver capturing evidence during a vehicle refuelling event" /></picture>
          <img className="fleetcore-fuel-transaction-evidence__record" src={fleetcoreFuelTransactionEvidenceRecord} alt="FleetCore fuel-event record linking driver, vehicle, odometer and litres" />
        </div>
      </div>
    </section>
  );
}